import { assertNever } from '@freelancer/utils';
import { CurrencyCode } from '../currencies/currencies.seed';
import { ExchangeRate } from './exchange-rates.model';

export interface GenerateExchangeRatesOptions {
  readonly currencyCodes: readonly CurrencyCode[];
}

export function generateExchangeRateObject(
  currencyCode: CurrencyCode,
): ExchangeRate {
  switch (currencyCode) {
    case CurrencyCode.USD:
      return {
        id: 'USD',
        from: {
          COP: 0.000283,
          USD: 1,
          QAR: 0.260918,
          IDR: 0.000069,
          AED: 0.25863,
          GBP: 1.248337,
          DKK: 0.140885,
          CAD: 0.722093,
          PKR: 0.006147,
          MXN: 0.05081,
          HUF: 0.003131,
          VND: 0.000041,
          RON: 0.220091,
          TKN: 0,
          MYR: 0.233558,
          SAR: 0.253232,
          SEK: 0.099892,
          SGD: 0.704349,
          JMD: 0.006902,
          AUD: 0.652512,
          CHF: 0.98109,
          KRW: 0.000814,
          CNY: 0.137546,
          TRY: 0.160463,
          BDT: 0.011207,
          NZD: 0.625965,
          CLP: 0.001083,
          THB: 0.03127,
          EUR: 1.0534,
          ARS: 0.021005,
          NOK: 0.105777,
          RUB: 0.015346,
          INR: 0.013366,
          JPY: 0.008661,
          BRL: 0.227132,
          HKD: 0.122203,
          PLN: 0.248408,
          PHP: 0.018644,
          ZAR: 0.066348,
          ILS: 0.274431,
        },
      };
    case CurrencyCode.NZD:
      return {
        id: 'NZD',
        from: {
          COP: 0.000429,
          USD: 1.441773,
          QAR: 0.395726,
          IDR: 0.000105,
          AED: 0.392257,
          GBP: 1.894546,
          DKK: 0.213676,
          CAD: 1.09589,
          PKR: 0.009322,
          MXN: 0.077062,
          HUF: 0.004749,
          VND: 0.000062,
          RON: 0.333805,
          TKN: 0,
          MYR: 0.354232,
          SAR: 0.384071,
          SEK: 0.151503,
          SGD: 1.068959,
          JMD: 0.010467,
          AUD: 0.99029,
          CHF: 1.487992,
          KRW: 0.001235,
          CNY: 0.208611,
          TRY: 0.243368,
          BDT: 0.016997,
          NZD: 1,
          CLP: 0.001666,
          THB: 0.047427,
          EUR: 1.598699,
          ARS: 0.032575,
          NOK: 0.160428,
          RUB: 0.023275,
          INR: 0.020284,
          JPY: 0.013136,
          BRL: 0.344484,
          HKD: 0.185463,
          PLN: 0.376754,
          PHP: 0.028277,
          ZAR: 0.100628,
          ILS: 0.416223,
        },
      };
    case CurrencyCode.AUD:
      return {
        id: 'AUD',
        from: {
          COP: 0.000412,
          USD: 1.383115,
          QAR: 0.379724,
          IDR: 0.000102,
          AED: 0.376395,
          GBP: 1.817468,
          DKK: 0.205036,
          CAD: 1.051303,
          PKR: 0.008945,
          MXN: 0.073945,
          HUF: 0.004557,
          VND: 0.00006,
          RON: 0.320307,
          TKN: 0,
          MYR: 0.339907,
          SAR: 0.368538,
          SEK: 0.145377,
          SGD: 1.025469,
          JMD: 0.010044,
          AUD: 1,
          CHF: 1.427818,
          KRW: 0.001185,
          CNY: 0.200175,
          TRY: 0.233527,
          BDT: 0.01631,
          NZD: 0.911349,
          CLP: 0.001589,
          THB: 0.04551,
          EUR: 1.533657,
          ARS: 0.031095,
          NOK: 0.153941,
          RUB: 0.022335,
          INR: 0.019459,
          JPY: 0.012605,
          BRL: 0.330553,
          HKD: 0.177917,
          PLN: 0.361518,
          PHP: 0.027133,
          ZAR: 0.096559,
          ILS: 0.399391,
        },
      };
    case CurrencyCode.GBP:
      return {
        id: 'GBP',
        from: {
          COP: 0.000216,
          USD: 0.722962,
          QAR: 0.198495,
          IDR: 0.000053,
          AED: 0.196755,
          GBP: 1,
          DKK: 0.107179,
          CAD: 0.549522,
          PKR: 0.004676,
          MXN: 0.038654,
          HUF: 0.002383,
          VND: 0.000031,
          RON: 0.167436,
          TKN: 0,
          MYR: 0.177681,
          SAR: 0.192649,
          SEK: 0.075993,
          SGD: 0.536019,
          JMD: 0.005251,
          AUD: 0.49657,
          CHF: 0.746372,
          KRW: 0.000619,
          CNY: 0.104639,
          TRY: 0.122073,
          BDT: 0.008525,
          NZD: 0.476367,
          CLP: 0.000838,
          THB: 0.023789,
          EUR: 0.801651,
          ARS: 0.017391,
          NOK: 0.080471,
          RUB: 0.011675,
          INR: 0.010171,
          JPY: 0.006589,
          BRL: 0.172792,
          HKD: 0.092998,
          PLN: 0.188979,
          PHP: 0.014184,
          ZAR: 0.050474,
          ILS: 0.208776,
        },
      };
    case CurrencyCode.HKD:
      return {
        id: 'HKD',
        from: {
          COP: 0.002202,
          USD: 7.385224,
          QAR: 2.02837,
          IDR: 0.000542,
          AED: 2.010589,
          GBP: 9.70447,
          DKK: 1.095239,
          CAD: 5.613493,
          PKR: 0.047781,
          MXN: 0.394996,
          HUF: 0.024344,
          VND: 0.000319,
          RON: 1.710985,
          TKN: 0,
          MYR: 1.815685,
          SAR: 1.968625,
          SEK: 0.776557,
          SGD: 5.475551,
          JMD: 0.053651,
          AUD: 5.072578,
          CHF: 7.626987,
          KRW: 0.006328,
          CNY: 1.069279,
          TRY: 1.247432,
          BDT: 0.087123,
          NZD: 4.866203,
          CLP: 0.008481,
          THB: 0.243097,
          EUR: 8.189047,
          ARS: 0.164806,
          NOK: 0.822309,
          RUB: 0.119302,
          INR: 0.103901,
          JPY: 0.06733,
          BRL: 1.765718,
          HKD: 1,
          PLN: 1.931122,
          PHP: 0.144936,
          ZAR: 0.515789,
          ILS: 2.13343,
        },
      };
    case CurrencyCode.SGD:
      return {
        id: 'SGD',
        from: {
          COP: 0.000382,
          USD: 1.281326,
          QAR: 0.351934,
          IDR: 0.000094,
          AED: 0.348849,
          GBP: 1.683712,
          DKK: 0.19003,
          CAD: 0.973932,
          PKR: 0.008291,
          MXN: 0.068534,
          HUF: 0.004224,
          VND: 0.000055,
          RON: 0.296866,
          TKN: 0,
          MYR: 0.315032,
          SAR: 0.341568,
          SEK: 0.134738,
          SGD: 1,
          JMD: 0.009309,
          AUD: 0.880085,
          CHF: 1.323327,
          KRW: 0.001098,
          CNY: 0.185526,
          TRY: 0.216437,
          BDT: 0.015116,
          NZD: 0.844279,
          CLP: 0.00148,
          THB: 0.042179,
          EUR: 1.420788,
          ARS: 0.029127,
          NOK: 0.142676,
          RUB: 0.0207,
          INR: 0.018026,
          JPY: 0.011682,
          BRL: 0.306363,
          HKD: 0.164824,
          PLN: 0.335061,
          PHP: 0.025147,
          ZAR: 0.089493,
          ILS: 0.370163,
        },
      };
    case CurrencyCode.EUR:
      return {
        id: 'EUR',
        from: {
          COP: 0.000256,
          USD: 0.85675,
          QAR: 0.23544,
          IDR: 0.000063,
          AED: 0.233377,
          GBP: 1.125802,
          DKK: 0.127129,
          CAD: 0.651214,
          PKR: 0.005546,
          MXN: 0.045849,
          HUF: 0.002825,
          VND: 0.000037,
          RON: 0.1986,
          TKN: 0,
          MYR: 0.210754,
          SAR: 0.228506,
          SEK: 0.090138,
          SGD: 0.635211,
          JMD: 0.006227,
          AUD: 0.588463,
          CHF: 0.885295,
          KRW: 0.000734,
          CNY: 0.124116,
          TRY: 0.144794,
          BDT: 0.010113,
          NZD: 0.564521,
          CLP: 0.000979,
          THB: 0.028217,
          EUR: 1,
          ARS: 0.018732,
          NOK: 0.095448,
          RUB: 0.013848,
          INR: 0.012054,
          JPY: 0.007816,
          BRL: 0.204954,
          HKD: 0.110209,
          PLN: 0.224153,
          PHP: 0.016824,
          ZAR: 0.05987,
          ILS: 0.247636,
        },
      };
    case CurrencyCode.CAD:
      return {
        id: 'CAD',
        from: {
          COP: 0.000372,
          USD: 1.249839,
          QAR: 0.343216,
          IDR: 0.000091,
          AED: 0.340207,
          GBP: 1.642337,
          DKK: 0.185323,
          CAD: 1,
          PKR: 0.008085,
          MXN: 0.066836,
          HUF: 0.004119,
          VND: 0.000054,
          RON: 0.289513,
          TKN: 0,
          MYR: 0.307228,
          SAR: 0.333107,
          SEK: 0.131399,
          SGD: 0.926656,
          JMD: 0.009078,
          AUD: 0.858458,
          CHF: 1.290547,
          KRW: 0.001071,
          CNY: 0.18093,
          TRY: 0.211076,
          BDT: 0.014742,
          NZD: 0.823532,
          CLP: 0.001441,
          THB: 0.041134,
          EUR: 1.385874,
          ARS: 0.027792,
          NOK: 0.139141,
          RUB: 0.020187,
          INR: 0.017584,
          JPY: 0.011392,
          BRL: 0.298773,
          HKD: 0.160773,
          PLN: 0.326761,
          PHP: 0.024524,
          ZAR: 0.087276,
          ILS: 0.360993,
        },
      };
    case CurrencyCode.INR:
      return {
        id: 'INR',
        from: {
          COP: 0.020133,
          USD: 67.525573,
          QAR: 18.545887,
          IDR: 0.00495,
          AED: 18.383309,
          GBP: 88.731222,
          DKK: 10.014036,
          CAD: 51.326046,
          PKR: 0.436876,
          MXN: 3.611539,
          HUF: 0.222579,
          VND: 0.002916,
          RON: 15.643956,
          TKN: 0,
          MYR: 16.60125,
          SAR: 17.999626,
          SEK: 7.100251,
          SGD: 50.064793,
          JMD: 0.490551,
          AUD: 46.380277,
          CHF: 69.735412,
          KRW: 0.057862,
          CNY: 9.77668,
          TRY: 11.405576,
          BDT: 0.796581,
          NZD: 44.493317,
          CLP: 0.077659,
          THB: 2.222698,
          EUR: 74.875191,
          ARS: 1.495887,
          NOK: 7.518567,
          RUB: 1.090809,
          INR: 1,
          JPY: 0.615613,
          BRL: 16.144401,
          HKD: 8.686167,
          PLN: 17.656722,
          PHP: 1.325187,
          ZAR: 4.715989,
          ILS: 19.506477,
        },
      };
    case CurrencyCode.TKN:
      return {
        id: 'TKN',
        from: {
          COP: 0,
          USD: 0,
          QAR: 0,
          IDR: 0,
          AED: 0,
          GBP: 0,
          DKK: 0,
          CAD: 0,
          PKR: 0,
          MXN: 0,
          HUF: 0,
          VND: 0,
          RON: 0,
          TKN: 0,
          MYR: 0,
          SAR: 0,
          SEK: 0,
          SGD: 0,
          JMD: 0,
          AUD: 0,
          CHF: 0,
          KRW: 0,
          CNY: 0,
          TRY: 0,
          BDT: 0,
          NZD: 0,
          CLP: 0,
          THB: 0,
          EUR: 0,
          ARS: 0,
          NOK: 0,
          RUB: 0,
          INR: 0,
          JPY: 0,
          BRL: 0,
          HKD: 0,
          PLN: 0,
          PHP: 0,
          ZAR: 0,
          ILS: 0,
        },
      };

    default:
      return assertNever(currencyCode);
  }
}
